import { EditOutlined, SaveOutlined } from '@ant-design/icons';
import { Input, message } from 'antd';
import React, { useState } from 'react';

type Props = {
  text: string;
  onSave: (value: string) => Promise<void>;
};

const EditableText = (props: Props) => {
  const [editing, setEditing] = useState(false);
  const [savedText, setSavedText] = useState(props.text);
  const [text, setText] = useState(props.text);
  const [loading, setLoading] = useState(false);

  if (!editing) {
    return (
      <span
        onClick={() => setEditing(true)}
        style={{ textDecoration: 'underline', cursor: 'pointer' }}
      >
        {text || '-'} <EditOutlined />
      </span>
    );
  }

  return (
    <Input.Search
      value={text}
      onChange={e => {
        e.persist();
        setText(e.target?.value || '');
      }}
      onKeyUp={e => {
        if (e.keyCode === 27) {
          setEditing(false);
          setText(savedText);
        }
      }}
      onSearch={async value => {
        try {
          setLoading(true);
          await props.onSave(value);
          setEditing(false);
          setSavedText(value);
          message.success('Updated!');
        } catch (error) {
          if (error.message) {
            message.error(error.message);
          }
          message.error('Failed to update');
        }
        setLoading(false);
      }}
      enterButton={<SaveOutlined />}
      loading={loading}
    />
  );
};

export default EditableText;
